import { Link, useNavigate } from "react-router-dom";
import useCustomerAuth from "../../legacy/hooks/useCustomerAuth";
import "../styles/mobile-header-redesign.css";

export default function MobileHeader({ showBack = false, backTo = "" }) {
  const navigate = useNavigate();
  const { customer, accessToken } = useCustomerAuth();
  const loggedIn = Boolean(customer && accessToken);
  const accountRoute = loggedIn ? "/account" : "/account/login";
  const accountLabel = loggedIn ? "Profile" : "Login";

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
      return;
    }
    navigate(-1);
  };

  return (
    <header className={`hv-mobile-header${showBack ? " hv-mobile-header--inner" : ""}`}>
      <div className="hv-mobile-header__inner">
        {showBack ? (
          <button className="hv-mobile-header__back" type="button" onClick={handleBack} aria-label="Go back">
            <i className="bi bi-chevron-left" aria-hidden="true" />
          </button>
        ) : null}

        <Link className="hv-mobile-header__brand" to="/" aria-label="Homevilas home">
          <img src="/logo512.png?v=homevilas-new" alt="Homevilas" className="hv-mobile-header__logo" />
        </Link>

        <div className="hv-mobile-header__actions">
          <Link className="hv-mobile-header__action" to="/help" aria-label="Support" title="Support">
            <i className="bi bi-headset" aria-hidden="true" />
          </Link>
          <Link className="hv-mobile-header__action" to={accountRoute} aria-label={accountLabel} title={accountLabel}>
            <i className="bi bi-person" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </header>
  );
}
